import {MAP_PROPS_ANIMAL_CONFIG} from "@/config/globalAnimalFrontEndConfig";

export const GET_ANIMALS_RECOMENDATION = "GET_ANIMALS_RECOMENDATION";
export const GET_SIMILAR_ENTITIES = "GET_SIMILAR_ENTITIES";
export const ERROR_GET_SIMILAR_ENTITIES = "ERROR_GET_SIMILAR_ENTITIES";


// =========================================================================
//                             GETS ANIMALS
// =========================================================================

// -------------------------
// GENERAL
// -------------------------

export function getAnimalsRecomendation(filter) {
    return (dispatch, getState) => {

        //console.log("actionsRecomendations::getAnimalsRecomendation()");

        //TODO 23/2/22 21:42: apaño temporal para las recomendaciones en base aun animal usando la busqueda
        if (filter.ignoreList && Array.isArray(filter.ignoreList)) {

            filter.ignoreList.push(filter.animal_id)
        } else {
            filter.ignoreList = [filter.animal_id]
        }


        // datos.num = filter.metadata.num;
        // datos.pag = filter.metadata.pag;
        let datos = {
            filter: parserFilter(filter),
            metadata: parserMetadata(filter.metadata)
        }

        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            //data: JSON.stringify(datos),
            data: datos,
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // URL a la que se enviará la solicitud Ajax
            url: "/api/busqueda/animal",
        })
            .done(function (response, textStatus, jqXHR) {
                //console.log(response);

                dispatch({type: GET_ANIMALS_RECOMENDATION, payload: response});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
        // });
    }

}

export function getSimilarEntitiesRecomendation(filter) {
    return (dispatch, getState) => {
        
        //console.log("actionsRecomendations::getAnimalsRecomendation()");
        //TODO 28/12/22 21:42: apaño temporal para las recomendaciones en base aun animal usando la busqueda
        if (filter.ignoreList && Array.isArray(filter.ignoreList)) {

            filter.ignoreList.push(filter.entity_id)
        } else {
            filter.filter.ignoreList = [filter.filter.entity_id]
            filter.filter.entity_id=undefined
        }
        
        
        let datos = {...filter}
        datos.num = filter.metadata.num;
        datos.pag = filter.metadata.pag;
        
        
        $.ajax({
                //Cambiar a type: POST si necesario
                type: "GET",
                //Datos que se envian
                //data: JSON.stringify(datos),
                data: datos,
                // Formato de datos que se espera en la respuesta
                dataType: "json",
                // URL a la que se enviará la solicitud Ajax
                url: "/api/busqueda/entity",
            })
            .done(function (response, textStatus, jqXHR) {
                //console.log(response);
                
                dispatch({type: GET_SIMILAR_ENTITIES, payload: response});
                dispatch({type: ERROR_GET_SIMILAR_ENTITIES, payload: undefined});
    
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }
                
                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
        // });
    }
    
}


export function resetAnimalsRecomendation() {
    //console.log("actionsRecomendations::resetAnimalsRecomendation()");
    return (dispatch, getState) => {
        dispatch({type: GET_ANIMALS_RECOMENDATION, payload: {}});
    }
}

export function resetSimilarEntitiesRecomendation() {
    //console.log("actionsRecomendations::resetAnimalsRecomendation()");
    return (dispatch, getState) => {
        dispatch({type: GET_SIMILAR_ENTITIES, payload: {}});
    }
}




function parserMetadata(metadata) {
    return metadata
}

function parserFilter(filter) {
    let dataReturn = {};
    Object.keys(filter).forEach((val) => {
        if (val === "especie" && filter[val] !== undefined){
            if (filter[val] !== MAP_PROPS_ANIMAL_CONFIG.especie.default.value){
                dataReturn.especie = filter[val];
            }
        } else if (val === "sexo" && filter[val] !== undefined){
            if (filter[val] === MAP_PROPS_ANIMAL_CONFIG.sexo.macho.value || filter[val] === MAP_PROPS_ANIMAL_CONFIG.sexo.hembra.value){
                dataReturn.sexo = filter[val];
            }
        } else if (val === "tamano" && filter[val] !== undefined && filter[val].length > 0){
            dataReturn.tamano = filter[val].join(",");
        } else if (val === "edades" && filter[val] !== undefined && filter[val].length > 0){
            dataReturn.edad = filter[val].join(",");
        } else if (val === "razas" && filter[val] !== undefined && filter[val].length > 0){
            if (filter[val].findIndex(x => x === "TODAS") < 0){
                dataReturn.raza = filter[val].join(",");
            }
        } else if (val === "raza" && filter[val] !== undefined && filter[val].length > 0){
            // if (data[val] !== "TODAS") {
            if (filter[val] !== undefined){
                dataReturn.raza = filter[val];
            }
        }
        if (val === "estado" && filter[val] !== undefined){
            dataReturn.estado = filter[val];
        } else if (val === "estadoUrgente" && filter[val] !== undefined){
            dataReturn.estadoUrgente = filter[val];
        } else if (val === "colores" && filter[val] !== undefined){
            if (filter[val].findIndex(x => x === MAP_PROPS_ANIMAL_CONFIG.color.default.label) < 0){
                dataReturn.color = filter[val].join(",");
            }
        } else if (val === "caracters" && filter[val] !== undefined){
            if (filter[val].findIndex(x => x === "TODOS") < 0){
                dataReturn.caracter = filter[val].join(",");
            }
        } else if (val === "chip" && filter[val] !== undefined){
            dataReturn.chip = filter[val];
        } else if (val === "vacuna" && filter[val] !== undefined){
            dataReturn.vacunas = filter[val];
        } else if (val === "ppp" && filter[val] !== undefined){
            dataReturn.ppp = filter[val];
        } else if (val === "ignoreList" && filter[val] !== undefined){
            dataReturn.ignoreList = filter[val];
        } else if (val === "id_protectora" && filter[val] !== undefined){
            dataReturn.id_protectora = filter[val];
        }
    });

    return dataReturn;
}

